import React, { useEffect, useRef, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import P250 from "../250/P250";
// import { InputText } from "primereact/inputtext";
import { FileUpload } from "primereact/fileupload";
import "./Tab.css";
import { Toast } from "primereact/toast";
import { Loading } from "../../../components/Loading/Loading";
import { genGetBranchInfo, genPhotoList, genPhotoUpdate } from "../../../service/GEN/GenService";
import { commonUpload } from "../../../service/APP/AppService";
import { formatDateFile } from "../../../utilities/DateUtil";
import ValidateService from "../../../components/ValidateService/ValidateService";
import { DialogShow } from "../../../components/DialogService/DialogService";
import { ipAddressSession } from "../../../utilities/dataSession";
import { deCodeBase64 } from "../../../components/UploadPic/UploadPicUtil";

export default function P206GenDialogV2({ dialog, setDialog, searchData, tabCode }) {
    const toast = useRef(null);
    let arrSetDataFile = [];

    const [showDialog, setShowDialog] = useState(false);
    const [textShow, setTextShow] = useState("");

    const [loading, setLoading] = useState(false);
    const [dataFile, setDataFile] = useState([]);
    const [tmpFile, setTmpFile] = useState([]);
    const [errData, setErrData] = useState(null);
    const [dataTable, setDataTable] = useState([]);

    useEffect(() => {
        onGenPhotoList();
    }, [tabCode]);

    // useEffect(() => {
    //     console.log("dataFile ", dataFile);
    // }, [dataFile]);

    useEffect(() => {
        if (dialog && dialog.act && dialog.act === "reload") {
            setDialog({ ...dialog, dialog: true, show: true });
        } else if (dialog && dialog.act && dialog.act === "save") {
            setDialog({ ...dialog, dialog: true, show: false });
        }
    }, [dialog.act]);

    const onSaveFile = () => {
        setLoading(true);
        for (let i = 0; i < dataFile.length; i++) {
            let reqGen = {
                orderNo: "",
                requestNo: searchData.requestNo,
                userId: searchData.userId,
            };

            genGetBranchInfo(reqGen).then(
                (res) => {
                    setLoading(false);
                    if (res && res.length > 0) {
                        setTimeout(() => {
                            onUpload(res[0], i);
                        }, 1000);
                    } else {
                        showMessages("error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.statusText}`);
                    }
                },
                function (err) {
                    setLoading(false);
                    setErrData(err);
                }
            );
        }
    };

    const onUpload = async (dataObj, i) => {
        let req = {
            base64Pic: deCodeBase64(dataFile[i].fileUpload),
            picName: formatDateFile(new Date(), true) + "_" + tabCode + "_" + i + "_" + +searchData.requestNo,
            requestNo: searchData.requestNo,
            userId: searchData.userId,
            branchId: dataObj.branchCode,
            fiscalYear: dataObj.fiscalYear,
            picType: dataFile[i].fileUpload.typefile,
        };
        setLoading(true);
        await commonUpload(req).then(
            (res) => {
                setLoading(false);
                if (res && res.status === "Success") {
                    const old = dataFile[i];
                    const modifly = { ...old, picPath: res.picPath, picUrl: res.picUrl };

                    setDataFile(modifly);
                    onGenPhotoUpdate(modifly, "บันทึก");
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด  Status Code: ${res.status}`, `Common Upload  : ${res.statusText}`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );

        // uploadFile(null, null, null, "CLEAR");
        setDialog({ dialog: false, show: false, act: "reload" });
        onClearFile();
    };

    const onGenPhotoUpdate = (newData, action) => {
        let req = {};
        if (action === "ลบรายการ") {
            req = {
                actionCode: "D",
                originalId: searchData.userId,
                photoDesc: "",
                photoPath: newData.photoPath,
                photoSeq: newData.photoSeq,
                photoType: tabCode,
                requestNo: searchData.requestNo,
                thumbnailPath: newData.thumbnailPath,
                userId: searchData.userId,
            };
        } else if (action === "บันทึก") {
            req = {
                actionCode: "A",
                // originalId: ipAddressSession() ? ipAddressSession().ipAddress : "",
                originalId:"",
                photoDesc: "",
                photoPath: newData.picPath,
                photoSeq: 0,
                photoType: tabCode,
                requestNo: searchData.requestNo,
                thumbnailPath: newData.picPath,
                userId: searchData.userId,
            };
        }

        setLoading(true);
        genPhotoUpdate(req).then(
            (res) => {
                setLoading(false);

                if (res.status === 200) {
                    if (res.data[0].statusText === "") {
                        if (res.data[0].statusCode === "C") {
                            setTextShow(`บันทึกสมบูรณ์ `);
                        } else if (res.data[0].statusCode === "E") {
                            setTextShow(`มีข้อผิดพลาด`);
                        }
                    } else {
                        setTextShow(`${res.data[0].statusText}`);
                    }
                    // setShowDialog(true);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.statusText}`);
                }
                onGenPhotoList();
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const onGenPhotoList = () => {
        let req = {
            photoType: tabCode,
            requestNo: searchData.requestNo,
            userId: searchData.userId,
        };

        setLoading(true);
        genPhotoList(req).then(
            (res) => {
                setLoading(false);
                if (res.data !== undefined) {
                    let temp = [];
                    let index = 1;
                    res.data.forEach((element) => {
                        temp.push({
                            ...element,
                            index: index,
                        });
                        index++;
                    });
                    setDataTable(temp);
                } else {
                    showMessages("error", `เกิดข้อผิดพลาด Status Code: ${res.status}`, `${res.statusText}`);
                }
            },
            function (err) {
                setLoading(false);
                setErrData(err);
            }
        );
    };

    const uploadFile = async (invoiceFile, fileName, file, checkSave) => {
        setLoading(true);
        if (checkSave === "CLEAR") {
            setDataFile([]);
            setTmpFile([]);
            arrSetDataFile = [];
        } else {
            let typefile = fileName.substr(fileName.lastIndexOf(".") + 1).split(".")[0];
            let data_file = {
                base64String: invoiceFile,
                fileName: fileName,
                file: file,
                typefile: typefile,
            };
            let arr = [];
            arr.push({ fileUpload: data_file });
            arrSetDataFile.push(...arr);
            setDataFile([...dataFile, ...arrSetDataFile]);
        }
        setLoading(false);
    };
    // console.log(dataFile);
    const fileUploadHandler = ({ files }) => {
        let arr = [];
        files.forEach((element) => {
            const fileReader = new FileReader();
            fileReader.onload = (e) => {
                uploadFile(e.currentTarget.result, element.name, element);
            };

            fileReader.readAsDataURL(element);
            arr.push({ selectImg: element });
        });
        setTmpFile(arr);
    };

    const onClearFile = async () => {
        try {
            uploadFile(null, null, null, "CLEAR");
            setTmpFile([]);
            arrSetDataFile = [];

            setDialog({ dialog: true, show: false, act: "reload" });
        } catch (error) {}
    };
    const onClose = () => {
        try {
            uploadFile(null, null, null, "CLEAR");
            setTmpFile([]);
            arrSetDataFile = [];
        } catch (error) {}
        setDialog({ ...dialog, dialog: false, show: true });
    };

    const onCloseMain = () => {
        setDataFile([]);
        setDialog({ ...dialog, dialog: false, show: true });
    };
    const renderFooter = () => {
        return (
            <>
                <div className="p-col-12 p-md-12">
                    <div style={{ height: "20px" }} />
                    <div className="p-grid" style={{ textAlign: "center" }}>
                        <div className="p-col-12">
                            {dataTable && dataTable.length > 0 ? (
                                <Button
                                    className="p-button p-button-success"
                                    icon="pi pi-upload"
                                    label="อัพโหลด"
                                    style={{ width: 200, marginTop: "10px" }}
                                    onClick={() => setDialog({ ...dialog, dialog: true, show: true })}
                                    // onClick={() => submitForm()}
                                />
                            ) : (
                                ""
                            )}

                            <Button
                                className="p-button-danger p-button"
                                icon="pi pi-times"
                                label="ปิดหน้าจอ"
                                // style={{ marginLeft: '5px' }}
                                style={{ width: 200, marginLeft: "5px", marginTop: "10px" }}
                                onClick={() => onCloseMain()}
                            />
                        </div>
                    </div>
                </div>
            </>
        );
    };

    const showMessages = (severity = "error", summary = "", detail = "") => {
        toast.current.show({ severity: severity, summary: summary, detail: detail, life: 10000 });
    };

    return (
        <>
            <Dialog header={dialog && dialog.show === false ? "รูปถ่าย" : "เพิ่มรูปถ่าย"} visible={dialog.dialog} style={{ width: "70vw" }} className="p-fluid ___widthDialog" onHide={() => onCloseMain()} blockScroll={true} maximizable={true}>
                <ValidateService err={errData} setErr={setErrData} />
                <Loading loading={loading} />
                <Toast ref={toast} position="top-right" />
                <div className="p-grid crud-demo">
                    <div className="p-col-12">
                        {dialog.show === false ? (
                            <>
                                <P250 footer={renderFooter} onGenPhotoUpdate={onGenPhotoUpdate} searchData={searchData} tabCode={tabCode} dataTable={dataTable}></P250>
                            </>
                        ) : (
                            <div className="p-grid p-fluid media-demo">
                                <div className="p-col-12">
                                    <div className="card">
                                        <div className="p-grid  p-fluid">
                                            <div className="p-col-12 p-md-12 " style={{ textAlign: "center" }}>
                                                {/* <h5><u><b>เพิ่มรูปถ่าย</b></u></h5>     */}
                                            </div>

                                            <div className="p-col-12 p-md-12 upload-responsive " style={{ textAlign: "right" }}>
                                                <FileUpload
                                                    id="picup"
                                                    name={tmpFile.selectImg}
                                                    accept="image/*"
                                                    // maxFileSize={1000000}
                                                    chooseLabel={"เลือกไฟล์"}
                                                    className="span-upload-responsive"
                                                    // disabled={tmpFile.selectImg && tmpFile.selectImg != null ? true : false}

                                                    customUpload={true}
                                                    uploadHandler={fileUploadHandler}
                                                    emptyTemplate={
                                                        <div className="p-col-12 p-md-12 upload-responsive " style={{ textAlign: "left" }}>
                                                            <p>ลากไฟล์วาง</p>
                                                        </div>
                                                    }
                                                    multiple
                                                    auto
                                                />
                                            </div>
                                        </div>
                                        <div className="p-grid" style={{ textAlign: "center" }}>
                                            <div className="p-col-12">
                                                <Button className="p-button p-button-success p-button p-mr-2 p-mb-2" icon="pi pi-upload" label="อัปโหลด" disabled={tmpFile && tmpFile.length > 0 ? false : true} style={{ width: 150 }} onClick={() => onSaveFile()} />
                                                <Button className="p-button-danger p-button p-button p-mr-2 p-mb-2" icon="pi pi-times" label="ปิดหน้าจอ"  onClick={() => onClose()} />  {/* style={{ width: "100%" }} */}                                               
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Dialog>

            <DialogShow visible={showDialog} header="แจ้งเตือน" modal onHide={() => setShowDialog(false)} className="p-fluid" textContent={textShow} btnCancle={() => setShowDialog(false)} />
        </>
    );
}
